import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./layout/Layout";
import Home from "./pages/public/Home";
import LegalNotice from "./pages/public/LegalNotice";
import Privacy from "./pages/public/Privacy";
import FAQ from "./pages/public/FAQ";
import Contact from "./pages/public/Contact";
import MisReservas from "./pages/cliente/MisReservas";
import ConductorServicios from "./pages/conductor/MisServicios";
import BolsaServicios from "./pages/conductor/BolsaServicios";
import ConductorPerfil from "./pages/conductor/Perfil";
import AdminInhabiles from "./pages/admin/AdminInhabiles";
import AdminStats from "./pages/admin/AdminStats";
import AdminClientes from "./pages/admin/AdminClientes";
import AdminConductores from "./pages/admin/AdminConductores"
import AdminReservas from "./pages/admin/AdminReservas";
import AdminQRs from "./pages/admin/AdminQRs";
import AdminCRUCliente from "./pages/admin/AdminCRUCliente";
import AdminCRUConductor from "./pages/admin/AdminCRUConductor";
import AdminMapa from "./pages/admin/AdminMapa"
import AdminEmail from "./pages/admin/AdminEmail"
import AdminSecurity from "./pages/admin/AdminSecurity"
import AdminScheduler from "./pages/admin/AdminScheduler"
import AdminSettings from "./pages/admin/AdminSettings"
import AdminVuelos from "./pages/admin/AdminVuelos"
import AdminChatSoporte from "./pages/admin/AdminChatSoporte";
import Login from "./pages/auth/Login";
import LoginConductor from "./pages/auth/LoginConductor";
import OauthCallbackGoogle from "./pages/auth/Oauth_callback_google";
import OauthCallbackTiktok from "./pages/auth/Oauth_callback_tiktok";
import OauthCallbackInstagram from "./pages/auth/Oauth_callback_instagram";
import OauthCallbackFacebook from "./pages/auth/Oauth_callback_facebook";
import LoginAdmin from "./pages/auth/Login-admin";
import LoginMulti from "./pages/auth/Login-multi";
import RegistroConductor from "./pages/auth/RegistroConductor";
import RegistroCliente from "./pages/auth/RegistroCliente";
import VerificarCodigo from "./pages/auth/VerificarCodigo";
import PrivateRoute from "./components/security/PrivateRoute";
import ReservaWizard from './components/ReservaWizard';

const App = () => {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route
            index
            element={<Home />}
          />
          <Route path="login-multi" element={<LoginMulti />} />
          <Route path="login" element={<Login />} />
          <Route path="login-conductor" element={<LoginConductor />} />
          <Route path="oauth-callback" element={<OauthCallbackGoogle />} />
          <Route path="oauth-callback-tiktok" element={<OauthCallbackTiktok />} />
          <Route path="oauth-callback-instagram" element={<OauthCallbackInstagram />} />
          <Route path="oauth-callback-facebook" element={<OauthCallbackFacebook />} />
          <Route path="aviso-legal" element={<LegalNotice />} />
          <Route path="verificar-codigo" element={<VerificarCodigo />} />
          <Route path="registro-conductor" element={<RegistroConductor />} />
          <Route path="registro-cliente" element={<RegistroCliente />} />
          <Route path="privacidad" element={<Privacy />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="contacto" element={<Contact />} />
          <Route path="conductor">
            <Route index element={<PrivateRoute><ConductorPerfil /></PrivateRoute>} />
            <Route path="servicio-activo" element={<PrivateRoute><ConductorServicios /></PrivateRoute>} />
            <Route path="bolsa-servicios" element={<PrivateRoute><BolsaServicios /></PrivateRoute>} />
            <Route path="historico" element={<PrivateRoute><ConductorServicios /></PrivateRoute>} />
          </Route>
          <Route path="cliente">
            <Route index element={<PrivateRoute><MisReservas /></PrivateRoute>} />
            <Route path="reserva" element={<ReservaWizard />} />
            <Route path="mis-reservas" element={<PrivateRoute><MisReservas /></PrivateRoute>} />
            <Route path="perfil" element={<PrivateRoute><AdminCRUCliente /></PrivateRoute>} />
            <Route path="reserva-activa" element={<PrivateRoute><MisReservas /></PrivateRoute>} />
            <Route path="historial" element={<PrivateRoute><MisReservas /></PrivateRoute>} />
          </Route>
          <Route path="admin">
            <Route path="login-admin" element={<LoginAdmin />} />
            <Route path="stats" element={<PrivateRoute><AdminStats /></PrivateRoute>} />
            <Route path="inhabiles" element={<PrivateRoute><AdminInhabiles /></PrivateRoute>} />
            <Route path="mapa" element={<PrivateRoute><AdminMapa /></PrivateRoute>} />
            <Route path="conductores" element={<PrivateRoute><AdminConductores /></PrivateRoute>} />
            <Route path="alta-conductor" element={<PrivateRoute><AdminCRUConductor /></PrivateRoute>} />
            <Route path="editar-conductor/:id" element={<PrivateRoute><AdminCRUConductor /></PrivateRoute>} />
            <Route path="clientes" element={<PrivateRoute><AdminClientes /></PrivateRoute>} />
            <Route path="alta-cliente" element={<PrivateRoute><AdminCRUCliente /></PrivateRoute>} />
            <Route path="editar-cliente/:id" element={<PrivateRoute><AdminCRUCliente /></PrivateRoute>} />
            <Route path="reservas" element={<PrivateRoute><AdminReservas /></PrivateRoute>} />
            <Route path="qrs" element={<PrivateRoute><AdminQRs /></PrivateRoute>} />
            <Route path="notificaciones/email" element={<PrivateRoute><AdminEmail /></PrivateRoute>} />
            <Route path="security" element={<PrivateRoute><AdminSecurity /></PrivateRoute>} />
              <Route path="chat_de_soporte" element={<PrivateRoute><AdminChatSoporte /></PrivateRoute>} />
            <Route path="scheduler" element={<PrivateRoute><AdminScheduler /></PrivateRoute>} />
            <Route path="settings" element={<PrivateRoute><AdminSettings /></PrivateRoute>} />
              <Route path="vuelos" element={<PrivateRoute><AdminVuelos /></PrivateRoute>} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default App;